import { newE2EPage } from "@stencil/core/testing";

describe("rendering", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-check-list></uic-check-list>`);
        const el = await page.find("uic-check-list");
        expect(el).toHaveClass("hydrated");
    });

    it("should display selected values correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-check-list>
                <uic-check-list-item uic-controller value="ALL">All</uic-check-list-item>
                <uic-check-list-item uic-controller group="1" value="1">Value 1</uic-check-list-item>
                <uic-check-list-item class="nested" group="1" value="1.1">Value 1.1</uic-check-list-item>
                <uic-check-list-item class="nested" group="1" value="1.2">Value 1.2</uic-check-list-item>
                <uic-check-list-item value="2">Value 2</uic-check-list-item>
                <uic-check-list-item value="3">Value 3</uic-check-list-item>
                <uic-check-list-item value="4">Value 4</uic-check-list-item>
            </uic-check-list>
        `);
        // eslint-disable-next-line
        const el = (await page.find("uic-check-list")) as any;
        el.setProperty("selectedValues", ["1.1", "2"]);
        const content = await el.find(".simplebar-content");
        await page.waitForChanges();
        expect(content).toMatchSnapshot();
    });
});
